// extracted by mini-css-extract-plugin
export default {"section":"AdditionalInsuranceMultipleItemContent_section__+ICBL","sectionMultiSelect":"AdditionalInsuranceMultipleItemContent_sectionMultiSelect__s4jRJ"};